export default __webpack_public_path__ + "static/media/annual_join_as_member_loyalty_bk.544c1cac.png";